// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PKeyOutlinedSvg from "@fishx/icons-svg/es/asn/PKeyOutlined";
import FishxIcon from '../components/FishxIcon';

var PKeyOutlined = function PKeyOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PKeyOutlinedSvg
  }));
};

PKeyOutlined.displayName = 'PKeyOutlined';
export default React.forwardRef(PKeyOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PKeyOutlined.js
// module id = 3469
// module chunks = 0